import http from "@/service/http";
import React from "react";
import qs from "qs";
import wx from "weixin-js-sdk";

export const WalkInContext = React.createContext({});
export const useWalkIn = () => React.useContext(WalkInContext);

let ua = navigator.userAgent.toLowerCase();
export let client = "desktop";
if (/Micromessenger/i.test(ua)) {
  client = "weixin";
} else if (
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|ArkWeb/i.test(
    ua,
  )
) {
  client = "mobile";
} else {
  client = "desktop";
}

function setWxConfig(config) {
  wx.config(config);
  return new Promise((resolve, reject) => {
    wx.ready(resolve);
    wx.error(reject);
  });
}

const cache = {};

const buyDeal = {
  async getScheme(uuid) {
    const cacheKey = uuid;
    if (cache[cacheKey]) return cache[cacheKey];
    const params = {
      path: "/profile/pay",
      query: `pay_uuid=${uuid}`,
    };
    return http
      .post(
        `https://api.diningcity.asia/public/wechat/get_generate_scheme?${qs.stringify(params)}`,
      )
      .then(({ data }) => {
        cache[cacheKey] = data.openlink;
        return data.openlink;
      });
  },
  /**
   * 添加优惠券
   */
  addVoucher(code) {
    return http.post(`/member/vouchers/${code}/entry`).then((res) => res.data);
  },
  /**
   * 获取优惠券使用规则
   */
  getVoucherRule({ project = "diningcity", deal_id, restaurant_id }) {
    return http
      .get(`/public/project_configs/${project}/voucher_info`, {
        params: {
          deal_id,
          restaurant_id,
        },
      })
      .then((res) => res.data);
  },
  /**
   * 获取优惠券列表
   */
  getVouchers({ deal_id, restaurant_id, project }) {
    return http
      .get(`/member/vouchers/available`, {
        params: {
          project: project || "diningcity",
          deal_id,
          restaurant_id,
          page: 1,
          per_page: 999,
        },
      })
      .then((res) => res.data);
  },
  /**
   * 获取支付信息
   */
  getPaymentInfo({
    restaurantId,
    vouchers,
    deal_id,
    project,
    number,
    uuid,
    payment_id,
  }) {
    return http
      .get(`/public/restaurants/${restaurantId}/payment_info`, {
        params: {
          project: project || "diningcity",
          vouchers,
          deal_id,
          number,
          uuid,
          payment_id,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { indices: false });
        },
      })
      .then((res) => res.data);
  },
  getPayResult(uuid) {
    return http.get(`/public/payments/${uuid}`).then((res) => res.data);
  },
  /**
   * 获取可用支付渠道
   */
  getPaymentMethods({ restaurant_id, access_code, payment_id, project }) {
    return http
      .get(`/public/payments/available_channels_detail`, {
        params: {
          project: project || "diningcity",
          from: client,
          restaurant_id,
          access_code,
          payment_id,
        },
      })
      .then((res) => res.data);
  },
  prePayment({ channel, uuid, success_url }) {
    return http
      .post(`/public/payments/${uuid}/pay`, {
        channel: channel,
        from: client,
        success_url: success_url,
      })
      .then((res) => res.data);
  },
  callPayment({ prePayment }) {
    return new Promise((resolve) => {
      import("pingpp-js").then((pingpp) => {
        try {
          pingpp.setUrlReturnCallback(
            (err, url) => {
              if (err) return console.error(err);
              window.top.location.href = url;
            },
            [prePayment.channel],
          );
          pingpp.createPayment(prePayment, (result, err) => {
            console.log("支付完成", result);
            console.log("支付完成", err, JSON.stringify(err));
            console.log("支付完成", result, err);
            if (result === "success") {
              resolve("success");
              // 只有微信公众账号 wx_pub 支付成功的结果会在这里返回，其他的支付结果都会跳转到 extra 中对应的 URL。
            } else if (result === "fail") {
              // charge 不正确或者微信公众账号支付失败时会在此处返回
              console.error("fail:", err);
              resolve("fail");
            } else if (result === "cancel") {
              // 微信公众账号支付取消支付
              console.error("cancel:", err);
              resolve("cancel");
            }
          });
        } catch (error) {
          console.error("fail:", error);
          resolve("fail");
        }
      });
    });
  },
  async getWxConfig() {
    if (client !== "weixin") return;
    return http
      .get(`https://api.diningcity.asia/public/test/wechat_jsapi_sign`, {
        params: {
          url: window.location.href,
        },
      })
      .then(({ data }) => {
        let config = {
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,
          jsApiList: ["navigateToMiniProgram"],
          openTagList: ["wx-open-launch-weapp"],
        };
        return setWxConfig(config);
      });
  },
};

export default buyDeal;

const mock = {
  vouchers: [
    {
      id: 257,
      code: "cdmdaw",
      start_at: "2025-05-16T00:00:00.000+08:00",
      end_at: "2026-05-16T23:59:59.000+08:00",
      project: "diningcity",
      points: 1,
      used: false,
      expired: false,
      can_refund: false,
      applicable: true,
      status: "usable",
      payment_status: null,
      amount_paid: null,
      refund_amount: null,
      qr_code: null,
      redeems: [],
      project_config: {
        title: "",
        project_type: "normal",
      },
      detail: {
        title: "Dr. Thaddeus Grant",
        desc: null,
        id: 27,
        name: "dc_20_off_2022",
        code_length: 6,
        points_type: "fixed",
        points_type_humanize: "Fixed",
        price: "0",
        currency: "￥",
        points: 1,
        amount: 1,
        start_on: "May 16, 2025",
        end_on: "May 16, 2026",
        value: null,
        type: "VoucherBatch",
        stock_count: null,
        voucher_per_seat: 1,
        price_type: null,
        batch_code: null,
        price_humanize: "",
        visible_consumer: true,
        validity_num: null,
        validity_unit: null,
        use_type: "book",
        deal: null,
        voucher_batch_assignment: null,
      },
    },
  ],
  payInfo: {
    origin_amount: 0,
    format_origin_amount: "￥488",
    amount: null,
    format_amount: "￥488",
    currency: "￥",
    currency_code: "",
    amount_type: null,
    amount_type_humanize: {
      pre_pay: "Pre-payment",
      voucher_pre_pay: "Vouchers pre-pay",
      no_payment: "No payment",
      pre_authorized: "Pre-authorized",
    },
    item_price: "￥488",
    item_count: 1,
    payment_mode: null,
    payment_mode_humanize: {
      pre_pay: "Pre-pay deal amount",
      deposit: "Deposit",
    },
  },
  payMethods: [
    {
      keyword: "wx",
      name: "Wechat",
      provider: "ping++",
      icon: "https://library.diningcity.cn/icons/pay_wx.png?aaa",
    },
  ],
};
